import Isotope from "isotope-layout"
import CategoryCard from "plugin/CategoryShortcuts/CategoryCard"

import IsotopeCards from "plugin/CategoryShortcuts/IsotopeCards"
import MasonryCard from "plugin/CategoryShortcuts/MasonryCard"
import React, {Component} from "react"
import {Card, Container} from "semantic-ui-react"
import cmsStore from "stores/cmsStore"
import "style/CategoryCard.scss"

window["Isotope"] = Isotope

export default class CategoryShortcuts extends Component {

	render() {
		const {category, children = null} = this.props
		const hasData = category && category.children &&  category.children.length > 0
		const title = this.props.title
		const useTitlebar = title && hasData
		const {masonryCategories} = cmsStore.config.plugin
		return (
			<React.Fragment>
				{hasData && children}
				<div className="MasonryContainer">
					{hasData && <div className="">
						{useTitlebar && <h2 className="mt2 ttu">{title}</h2>}
						{masonryCategories && <div>
							{hasData && <IsotopeCards key={category.map_id}>
								<div className="grid-sizer" />
								{category.children.map( subcat => {
									return <MasonryCard
										onReady={this.handleReady}
										hasParents={category.map_id} parents={[category.map_id]} key={subcat.map_id}
										category={subcat} />
								} )}
							</IsotopeCards>
							}
						</div>}

						{!masonryCategories && <div className="mb3" style={{display: "flex", justifyContent: "center" }}>
							<Card.Group itemsPerRow={4} doubling style={{display: "flex", justifyContent: "center" }}>
								{category.children.map( subcat => {
									if ( !subcat.active ) return null
									if ( subcat.isHidden ) return null
									return (
										<CategoryCard
											hasParents={category.map_id}
											parents={[category.map_id]}
											key={subcat.map_id}
											category={subcat}
										>
											{subcat.children && subcat.children.length > 0 && (
												<div>
													{subcat.children.map((subsubcat) => (
														<CategoryCard
															hasParents={category.map_id}
															parents={[category.map_id, subcat.map_id]}
															key={subsubcat.map_id}
															category={subsubcat}
														/>
													))}
												</div>
											)}
										</CategoryCard>
									);
								} )}
							</Card.Group>
						</div>}
					</div>}

				</div>
			</React.Fragment>

		)
	}
}



// WEBPACK FOOTER //
// ./src/plugin/CategoryShortcuts/CategoryShortcuts.js